import * as React from "react"
import { DetailText } from "@digits-shared/themes/typography"
import styled from "styled-components"
import dayjs from "@digits-shared/initializers/dayjs/dayjs"

const Title = styled(DetailText)`
  flex-shrink: 1;
`

export const DateTitle: React.FC<{
  occurredAfter?: Date
  occurredBefore?: Date
  className?: string
}> = ({ occurredAfter, occurredBefore, className }) => {
  const after = dayjs(occurredAfter).utc()
  const before = dayjs(occurredBefore).utc()

  if (occurredAfter && occurredBefore) {
    return (
      <Title className={className}>
        {after.format("MMMM D")} - {before.format("MMMM D")}, {before.format("YYYY")}
      </Title>
    )
  }

  if (occurredAfter && !occurredBefore) {
    return <Title className={className}>Since {after.format("MMMM D, YYYY")}</Title>
  }

  return <Title className={className}>All Time</Title>
}
